import React from 'react';
function Help({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect width="18" height="18" x="3" y="3" rx="2" />
      <path
        strokeLinecap="round"
        d="M12 13.5v-1 0c0-.64.254-1.254.707-1.707l.628-.628c.11-.11.208-.23.294-.359l.102-.152a2.08 2.08 0 000-2.308v0a2.08 2.08 0 00-.577-.577l-.068-.045a2.248 2.248 0 00-2.253-.14v0a2.248 2.248 0 00-1.127 1.3l-.065.194c-.093.28-.141.572-.141.867V9"
      />
      <path d="M12.5 17a.5.5 0 10-1 0 .5.5 0 001 0z" />
    </svg>
  );
}

export default Help;
